import { CSkeleton } from "./CSkeleton"

export const CSkeletonNavList = () => {

    return (
        <div className="w-full flex flex-col mt-[10px] md:mt-[20px] pr-[10px] md:pr-[20px]">
            {[0, 0, 0, 0, 0, 0 ,0 ,0].map((item: any, index: any) =>
                <div className={`w-full overflow-hidden rounded-[10px] overflow-hidden relative mb-[5px]`} >
                    <div className={`w-full h-[50px]  flex items-center cursor-pointer rounded-lg overflow-hidden relative `}>
                        <CSkeleton />
                    </div>
                </div>
            )}
        </div>
    )
}
